export default "__VITE_ASSET__89a50b69__"